import React, {useEffect, Fragment} from 'react';
import {FormattedMessage} from 'react-intl';
import {Auth} from '../layout/Auth';
import {goToLogin} from '../../helpers/location';
import {connect} from 'react-redux';
import {
  requestVerification,
  requestNewVerificationEmail
} from '../../store/actions/user';
import {getParamFromUrl} from '../../api/helper';
import {Messages} from '../../components/layout/Messages/Messages';
import {Row} from 'reactstrap';
import {ResendEmailVerificationSchema} from '../../helpers/schemas';
import {ErrorMessage, Field, Form, Formik} from 'formik';
import {EmailField} from '../../components/pages/auth/EmailField';
import './AccountVerify.scss';

function AccountVerifyComponent(props) {
  const {requestVerification, getParamFromUrl} = props;
  const {userId, verificationHash} = props.match.params;
  const expires = getParamFromUrl('expires', props);
  const signature = getParamFromUrl('signature', props);

  useEffect(() => {
    requestVerification(userId, verificationHash, expires, signature)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const {
    requestNewVerificationEmail,
    verificationSucceed,
    emailResend
  } = props;

  return (
    <div className="account-verify-page">
      <Auth title={<FormattedMessage id="app.account.verify.page_title"/>}>
        {
          (!verificationSucceed && !emailResend) &&
          <Formik
            initialValues={{email: ""}}
            validationSchema={ResendEmailVerificationSchema}
            onSubmit={(values) => {
              requestNewVerificationEmail(values.email)
            }}
          >
            {({handleBlur}) => (
              <Form className="account-verify-page__form mt-3">
                <Messages>
                  <ErrorMessage name="email" component="div"
                                data-testid="errors-email"
                                className="field-error"/>
                </Messages>
                <Row className="account-verify-page__message mb-3"><FormattedMessage
                  id="app.account.verify.resend_email"/></Row>
                <EmailField handleBlur={handleBlur}/>
                <div className="account-verify-page__actions text-center">
                  <FormattedMessage id="app.account.resend_btn">
                    {
                      valueBtn => <Field name="submit"
                                         className="account-verify-page__submit my-4 btn btn-info"
                                         color="info" type="submit"
                                         value={valueBtn}/>
                    }
                  </FormattedMessage>
                </div>
              </Form>
            )}
          </Formik>
        }
        {verificationSucceed && !emailResend &&
        <Fragment>
          <Messages/>
          <Row className="account-verify-page__message">
            <FormattedMessage id="app.account.verify.message"/>
          </Row>
        </Fragment>
        }
        {emailResend &&
        <Fragment>
          <Messages/>
          <Row className="account-verify-page__message">
            <FormattedMessage id="app.account.verify.resend_email_success"/>
          </Row>
        </Fragment>
        }
      </Auth>
    </div>
  );
}

AccountVerifyComponent.defaultProps = {
  goToLogin,
  getParamFromUrl
};


const mapStateToProps = state => ({
  verificationSucceed: state.user.verificationSucceed,
  emailResend: state.user.emailResend,
});

const mapActionsToProps = {
  requestVerification,
  requestNewVerificationEmail
};

const AccountVerify = connect(mapStateToProps, mapActionsToProps)(AccountVerifyComponent);

export {AccountVerify, AccountVerifyComponent};
